<template>
  <v-dialog v-model="dialog" persistent width="800px">
    <v-card>
      <v-card-title class="mx-3">
        <span class="accent--text pe-1">
          {{ value ? value.material_name : "" }}
        </span>
        {{ $t("MaterialTemplate.splitPrice") }}
        <v-spacer></v-spacer>
        {{ $t("MaterialTemplate.totalPrice") }}{{ $t("Global.colon") }}
        <span class="accent--text pe-4">
          {{ $t("Global.money") }}
          {{ price | formatMoney }}
        </span>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="sub_account_prices"
        :loading="loading"
        multi-sort
        disable-pagination
        hide-default-footer
        class="elevation-0 px-6"
        height="400px"
        fixed-header
      >
        <template v-slot:item.account="{ item }">
          {{ item.account }}
        </template>
        <template v-slot:item.price="{ item }">
          {{ $t("Global.money") }}{{ item.price | formatMoney }}
        </template>
      </v-data-table>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapState } from "vuex";
import i18n from "@/i18n";

export default {
  name: "SplitPrice",

  props: {
    value: Object,
    price: Number,
  },

  components: {},

  computed: {
    headers() {
      return [
        {
          text: i18n.t("MaterialTemplate.splitPrices.account"),
          align: "start",
          sortable: true,
          value: "account",
        },
        {
          text: i18n.t("MaterialTemplate.splitPrices.price"),
          align: "end",
          sortable: true,
          value: "price",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    dialog: false,
    sub_account_prices: [],
  }),

  mounted() {},

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.sub_account_prices = [];
          this.dialog = true;
          if (this.value.sub_account_price_json) {
            var accounts = Object.keys(this.value.sub_account_price_json);
            accounts.forEach((account) => {
              this.sub_account_prices.push({
                account: account,
                price: this.value.sub_account_price_json[account].price,
              });
            });
          }
        }
      },
    },

    dialog: {
      handler() {
        if (!this.dialog) {
          this.$emit("input", null);
        }
      },
    },
  },

  methods: {},
};
</script>